import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { useAuth } from '../context/AuthContext';

const API = process.env.REACT_APP_BACKEND_URL;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const params = new URLSearchParams(hash.substring(1));
    const sessionId = params.get('session_id');

    if (!sessionId) {
      navigate('/auth', { replace: true });
      return;
    }

    const exchangeSession = async () => {
      try {
        const res = await axios.post(
          `${API}/api/auth/google-session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        setUser(res.data);
        navigate('/dashboard', { replace: true });
      } catch {
        toast.error('Erreur lors de la connexion Google. Réessayez.');
        navigate('/auth', { replace: true });
      }
    };

    exchangeSession();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-[#0f0e17] flex flex-col items-center justify-center gap-4">
      <div className="w-10 h-10 rounded-full border-2 border-[#ff6b6b] border-t-transparent animate-spin" />
      <p className="text-[#a0a0ab] text-sm">Connexion en cours...</p>
    </div>
  );
}
